const colors = {
  azul: "#00A4B7",
  azulClaro: "#D7EAF1",
  azulEscuro: "#232752",
  vermelho: "#E7444D",
  cinza: "#a1a1a1",
};

export default colors;
